<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="페기물 처리결과" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="업로드"
                  icon="save" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-3">
                <c-plant required="true" type="edit" name="col0" v-model="data.col0" />
              </div>
              <div class="col-12">
              </div>
              <div class="col-12">
                <c-table
                  ref="table"
                  title="폐기물 처리현황 엑셀업로드결과"
                  tableId="processManual"
                  :columns="grid.columns"
                  gridHeight="400px"
                  :data="grid.data"
                  :columnSetting="false"
                  :isFullScreen="false"
                  :usePaging="false"
                  :expandAll="true"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                      <c-btn label="업로드결과 저장" icon="add" />
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'waste-upload',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
          psiDocumentId: '',
          documentClassCd: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      data: {
        col0: '',
      },
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '인계일',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '인계번호',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '폐기물 종류(성상)',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '위탁량',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col6',
            field: 'col6',
            label: '단위',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col7',
            field: 'col7',
            label: '운반자명',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col8',
            field: 'col8',
            label: '처리자명',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col9',
            field: 'col9',
            label: '처리방법',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col10',
            field: 'col10',
            label: '인계자명',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
  }
};
</script>